import React, {useContext, Suspense, lazy} from "react";
import "./Project.scss";
import Button from "../../components/button/Button";
import {openSource, socialMediaLinks} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import Loading from "../../containers/loading/Loading";

const featuredProjects = [
  {
    node: {
      id: "cubesat-adr",
      name: "CubeSatADR",
      description: "A CubeSat mission concept for active orbital-debris removal.",
      url: "https://github.com/ABanerjee33/CubeSatADR",
      forkCount: 0,
      stargazers: {totalCount: 2},
      diskUsage: 700474,
      primaryLanguage: {name: "Jupyter Notebook", color: "#DA5B0B"}
    }
  },
  {
    node: {
      id: "bwsi-cubesat",
      name: "BWSICubeSat",
      description: "A CubeSat concept using orbital systems to help clean up ocean plastics.",
      url: "https://github.com/ABanerjee33/BWSICubeSat",
      forkCount: 0,
      stargazers: {totalCount: 1},
      diskUsage: 1048,
      primaryLanguage: {name: "Python", color: "#3572A5"}
    }
  },
  {
    node: {
      id: "ble-proximity",
      name: "BLE Proximity Detection",
      description: "A Bluetooth-based proximity detection system built through the PiPACT program.",
      url: "https://github.com/ABanerjee33/BLE-COVIDProximityDetection",
      forkCount: 0,
      stargazers: {totalCount: 1},
      diskUsage: 2978,
      primaryLanguage: {name: "Python", color: "#3572A5"}
    }
  },
  {
    node: {
      id: "blood-glucose",
      name: "Blood Glucose Automation",
      description: "A healthcare project exploring more useful blood-glucose automation workflows.",
      url: "https://github.com/ABanerjee33/BloodGlucoseAutomation",
      forkCount: 0,
      stargazers: {totalCount: 1},
      diskUsage: 17186,
      primaryLanguage: {name: "CSS", color: "#563d7c"}
    }
  }
];

export default function Projects() {
  const GithubRepoCard = lazy(() =>
    import("../../components/githubRepoCard/GithubRepoCard")
  );
  const renderLoader = () => <Loading />;
  const {isDark} = useContext(StyleContext);
  if (openSource.display) {
    return (
      <Suspense fallback={renderLoader()}>
        <div className="main" id="opensource">
          <h1 className="project-title">Independent Projects</h1>
          <div className="repo-cards-div-main">
            {featuredProjects.map((v, i) => {
              if (!v) {
                console.error(
                  `Github Object for repository number : ${i} is undefined`
                );
              }
              return (
                <GithubRepoCard repo={v} key={v.node.id} isDark={isDark} />
              );
            })}
          </div>
          <Button
            text={"More Projects"}
            className="project-button"
            href={socialMediaLinks.github}
            newTab={true}
          />
        </div>
      </Suspense>
    );
  } else {
    return null;
  }
}
